import React, {useState} from 'react'
import styled from '@emotion/styled'
import {TranslatedCity} from 'components/CarouselWidgets/TopDealsForTonight/utils'

import {Pill} from '@vio/atlas/Pill'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

interface Props {
  items: TranslatedCity[]
  onPillClick: (index: number) => void
  isActive: boolean
}

const ScrollableWrapper = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  /* hide scrollbar */
  -ms-overflow-style: none; /* for Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari and Opera */
  }
  overflow-scrolling: touch;

  scroll-snap-type: x mandatory;
  scroll-padding: 0 ${cssTheme.layout.spacing.s200};
  padding-left: ${cssTheme.layout.spacing.s500};
  padding-right: ${cssTheme.layout.spacing.s500};
  > * + * {
    margin-left: ${cssTheme.layout.spacing.s300};
  }
  ${linariaMq.desktopXs} {
    padding-left: 0;
    padding-right: 0;
  }
`

const CitiesGroupSkeleton = () => {
  return (
    <ScrollableWrapper>
      {[...Array(4)].map((_, index) => (
        <SkeletonLoader key={`skl_${index}`} width={80} marginTop={0} />
      ))}
    </ScrollableWrapper>
  )
}

export const CitiesGroup = ({items, onPillClick, isActive}: Props) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const handleClick = (index: number) => () => {
    if (!isActive) return
    if (index !== activeIndex) {
      setActiveIndex(index)
      onPillClick?.(index)
    }
  }
  if (!items.length) return <CitiesGroupSkeleton />
  return (
    <ScrollableWrapper>
      {items.map((item, index) => (
        <Pill
          key={item.name}
          variant="default"
          isSelected={index === activeIndex}
          onClick={handleClick(index)}
        >
          {item.name}
        </Pill>
      ))}
    </ScrollableWrapper>
  )
}
